import * as addressApi from "@hub/simulator/src/api/address.api"
import createErrorMessage from "@shared/factories/src/errorMessage.factory"

export const fetchAddress = async (postcode, params) => {
  try {
    const data = await addressApi.fetchAddress(postcode, params)
    return data
  } catch (error) {
    console.error(error)
    window.$vue.$toast({
      type: "error",
      title:
        createErrorMessage(error).getMessage() ||
        "Falha ao obter dados do endereço"
    })
    throw error
  }
}

export const listCities = async params => {
  try {
    const { data } = await addressApi.listCities(params)
    return data
  } catch (error) {
    console.error(error)
    window.$vue.$toast({
      type: "error",
      title:
        createErrorMessage(error).getMessage() ||
        "Falha ao obter lista de cidades."
    })
  }
}

export const saveAddress = async payload => {
  try {
    const data = await addressApi.saveAddress(payload)
    return data
  } catch (error) {
    console.error(error)
    window.$vue.$toast({
      type: "error",
      title:
        createErrorMessage(error).getMessage() ||
        "Falha ao registrar dados do endereço."
    })
    throw error
  }
}

export const fetchAddressComplements = async params => {
  try {
    const data = await addressApi.fetchAddressComplements(params)
    return data
  } catch (error) {
    console.error(error)
    window.$vue.$toast({
      type: "error",
      title:
        error?.response?.data?.message ||
        "Falha ao buscar os complementos de endereços."
    })
    throw error
  }
}

export const fetchAddressByUserPosition = async params => {
  try {
    const data = await addressApi.fetchAddressByUserPosition(params)
    return data
  } catch (error) {
    console.error(error)
  }
}
